import React from "react";

const Terms = () => {
  const company_terms_and_condition = localStorage.getItem(
    "company_terms_and_condition"
  );
  return (
    <>
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{
          __html: company_terms_and_condition,
        }}
      />
    </>
  );
};

export default Terms;
